// @flow

import * as React from 'react';

import styles from './PandemicTimeEventsBanner.scss';

const WEDDING = '33';
const SAUNA_NIGHT = '34';
const DINNER = '37';
const RETREAT = '58';

export const NOT_ALLOWED_EVENT_TYPES = [WEDDING, SAUNA_NIGHT, DINNER, RETREAT];

const linkUrl = 'https://blog.venuu.fi/tag/korona-ajan-palvelut/';

type Props = {| onClick?: () => void |};

export default function PandemicTimeEventsBanner(props: Props): React.Node {
  return (
    <div className={styles.container}>
      <div className={styles.banner}>
        <div className={styles.text}>
          <p>Tapahtuma mielessä?</p>
          <p className={styles.ingress}>
            Tila- ja palveluvinkit poikkeusajan tarpeisiin!
          </p>
        </div>
        <a
          href={linkUrl}
          target="_blank"
          className={styles.cta}
          onClick={props.onClick}
        >
          LUE LISÄÄ
        </a>
      </div>
    </div>
  );
}
